"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_InsurancePlan_Plan = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_InsurancePlan_GeneralCost_1 = require("./RTTI_InsurancePlan_GeneralCost");
var RTTI_InsurancePlan_SpecificCost_1 = require("./RTTI_InsurancePlan_SpecificCost");
exports.RTTI_InsurancePlan_Plan = t.recursion('IInsurancePlan_Plan', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
        type: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        coverageArea: t.array(RTTI_Reference_1.RTTI_Reference),
        network: t.array(RTTI_Reference_1.RTTI_Reference),
        generalCost: t.array(RTTI_InsurancePlan_GeneralCost_1.RTTI_InsurancePlan_GeneralCost),
        specificCost: t.array(RTTI_InsurancePlan_SpecificCost_1.RTTI_InsurancePlan_SpecificCost)
    });
});
//# sourceMappingURL=RTTI_InsurancePlan_Plan.js.map